module.exports = __webpack_public_path__ + "media/images/smiley-team 2-de930c710ee54717c0f1bba1916d479f.png";